import React from "react";
import CNRPatches from "components/app/tool/cnr-patches";

const ScreenCNRPatches = () => {
	return <CNRPatches />;
};

export default ScreenCNRPatches;

